import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { TrackService } from '../track/track.service';

/**
 * Pushes an event to the tracker for every request and response
 */
@Injectable()
export class TrackInterceptor implements HttpInterceptor {
  constructor(private trackService: TrackService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestTimestamp = Math.round(performance.now());
    try {
      this.trackService.onHttpRequest(request, requestTimestamp);
    } catch (e) {
      console.warn(e);
    }
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          try {
            this.trackService.onHttpResponse(event, request, requestTimestamp);
          } catch (e) {
            console.warn(e);
          }
        }
      }),
      catchError((response: HttpErrorResponse) => {
        try {
          this.trackService.onHttpErrorResponse(response, request, requestTimestamp);
        } catch (e) {
          console.warn(e);
        }
        return throwError(response);
      })
    );
  }
}
